/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import _forEach from 'lodash/forEach';
import utilityService from '../../../../services/utility.service';
import ChartConst from '../../../../constants/chart.constant';
import DefConst from '../../../../constants/def.constant';
import AppConst from '../../../../constants/app.constant';

function removeDuplicatesByKeyFromObject(obj, key) {
  const hashesFound = {};
  let results;

  function hash(o, keyName) {
    return o[keyName];
  }
  if (obj) {
    obj.forEach((o) => {
      hashesFound[hash(o, key)] = o;
    });
    results = Object.keys(hashesFound).map((k) => hashesFound[k]);
  }
  return results || obj;
}

function getFavDisplayForAction(actionkey) {
  let display = '';

  DefConst.airportActions.forEach((value) => {
    if (value.key === actionkey) {
      display = value.text;
    }
  });
  return display;
}
const parseFavorites = (userFavoriteList) => {
  let favoriteList = utilityService.clone([...userFavoriteList]);
  favoriteList = removeDuplicatesByKeyFromObject(favoriteList, 'key');
  _forEach(favoriteList, (value) => {
    value.logDate = new Date(value.logDate);
    let temp;
    switch (value.stateName) {
      case AppConst.stateMap.dashboard.key:
        temp = value.key.split(':');
        if (temp.length === 3) {
          value.params.actionKey = ChartConst.defaultAction;
          value.key += `:${ChartConst.defaultAction}`;
        }
        if (value.params.start && value.params.product) {
          if (value.params.actionKey === 'meteogram') {
            value.displayValue = `${value.params.start.toUpperCase()} ${ChartConst.products[value.params.product.toLowerCase()].display_name}`;
          } else {
            value.displayValue = `${value.params.start.toUpperCase()} ${getFavDisplayForAction(value.params.actionKey)}`;
          }
        }
        break;
      case AppConst.stateMap.routeprofile.key:
      case AppConst.stateMap.leafletmapview.key:
      case AppConst.stateMap.mapview.key:
      case AppConst.stateMap.gridview.key:
        value.displayValue = `${value.params.start} > `;
        if (value.params.mid1 || value.params.mid2) {
          value.displayValue += '...';
          value.displayValue += ' > ';
        }
        value.displayValue += value.params.end;
        value.displayValue = value.displayValue.toUpperCase();
        break;
      case AppConst.stateMap.weather.key:
        /**
         * Todo: this should come from single place
         * create a menu.const as it is growing big
         */
        value.displayValue = `${value.params.start.toUpperCase()} 7-Day`;
        break;
      case AppConst.stateMap.avwxtab.key:
      case AppConst.stateMap.imagery.key:
        value.displayValue = value.params.subtab;
        if (value.params && value.params.pathkey2 && !value.key2) {
          value.key2 = `${value.stateName}:${value.params.pathkey2}`;
          value.key2 = value.key2.toLowerCase();
        }
        break;
      case AppConst.stateMap.workshops.key:
        value.displayValue = value.params.title;
        break;
      default:
    }
  });
  if (favoriteList) {
    _forEach(favoriteList.slice().reverse(), (item, index, object) => {
      // If display contains undefined or null then remove them
      if (
        !item.displayValue
        || (item.displayValue
          && (item.displayValue.toLowerCase().indexOf('undefined') > -1
            || item.displayValue.toLowerCase().indexOf('null') > -1))
      ) {
        favoriteList.splice(object.length - 1 - index, 1);
      }
    });
  }
  // Sort history data so that we show latest airport first
  return favoriteList ? favoriteList.sort(utilityService.sortByDate) : [];
};

export { parseFavorites };
